import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';
import { HtmlContentModule } from '@shared/html-content/html-content.module';
import { QuillModule } from 'ngx-quill';

import { FormRichTextComponent } from './form-rich-text.component';

// Register inline color attributors at module level
import Quill from 'quill';
try {
  const ColorStyle = Quill.import('attributors/style/color');
  const BackgroundStyle = Quill.import('attributors/style/background');
  Quill.register(ColorStyle, true);
  Quill.register(BackgroundStyle, true);
} catch (error) {
  console.error('Failed to register color attributors:', error);
}

export const imports: NgModule['imports'] = [
  FormErrorModule,
  FormsModule,
  HtmlContentModule,
  MatInputModule,
  QuillModule.forRoot(),
  ReactiveFormsModule,
];

@NgModule({
  declarations: [FormRichTextComponent],
  imports: [...imports, CommonModule],
  exports: [FormRichTextComponent],
})
export class FormRichTextModule {}
